// frontend/src/pages/GiftPage.js
import React from 'react';
import MainLayout from '../components/MainLayout';
import GiftStore from '../components/GiftStore';

function GiftPage() {
  const senderEmail = localStorage.getItem('user_email');
  const receiverEmail = 'cible@example.com'; // à remplacer dynamiquement si besoin

  return (
    <MainLayout>
      <div className="container mt-4">
        <h1 className="text-center">🎁 Boutique de Cadeaux</h1>
        <GiftStore senderEmail={senderEmail} receiverEmail={receiverEmail} />
      </div>
    </MainLayout>
  );
}

export default GiftPage;
